import React, { useContext } from "react";
import TeamStats from "../TeamStats/TeamStats";
import UITabs from "./UITabs";
import styled from "styled-components";
import { UIContext } from "../../contexts/UIContext";
import ButtonFactory from "../GraphicButtons/ButtonFactory";

function ComponentFactory({
  component,
  game,
  layout,
  group,
  previewGraphic,
  period,
  homeScorers,
  awayScorers,
  optaEvents,
  allOptaEvents,
  selectedPlayer,
  selectedSubPlayer,
}) {
  const { editUI } = useContext(UIContext);

  if (component?.data?.type === "TEAM_STATS") {
    return (
      <div className="relative w-full">
        {game?.opta_team_stats?.home ? (
          <TeamStats game={game} />
        ) : (
          <div>No Team Stats available</div>
        )}
        {editUI && (
          <>
            <div class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
              X
            </div>
            <div class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-blue-500 border-2 border-white rounded-full -top-2 -start-2 dark:border-gray-900">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                />
              </svg>
            </div>
          </>
        )}
      </div>
    );
  }
  if (component?.data?.type === "GRAPHIC") {
    return (
      <div className="relative w-[90%]">
        <ButtonFactory
          layout={layout}
          component={component}
          game={game}
          group={group}
          previewGraphic={previewGraphic}
          period={period}
          homeScorers={homeScorers}
          awayScorers={awayScorers}
          optaEvents={optaEvents}
          allOptaEvents={allOptaEvents}
          player={selectedPlayer}
          selectedSubPlayer={selectedSubPlayer}
        />
        {editUI && (
          <>
            <div class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full top-1 -end-2 dark:border-gray-900">
              X
            </div>
            <div class="cursor-pointer absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-blue-500 border-2 border-white rounded-full top-1 -start-2 dark:border-gray-900">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                />
              </svg>
            </div>
          </>
        )}
      </div>
    );
  }
  if (component?.data?.type === "TABS") {
    return (
      <>
        <UITabs
          tabs={component.children}
          game={game}
          editUI={editUI}
          layout={layout}
        />
      </>
    );
  }
}

export default ComponentFactory;
